import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76b6556a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-customers-photos-skeleton" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomersPhotosSkeleton',
  props: {
    isMobile: { type: Boolean, default: false },
    itemsCount: { default: 6 }
  },
  setup(__props: any) {

const props = __props;

const itemStyle = computed(() => {
  if (props.isMobile) {
    return {
      width: "calc((100% - 24px) / 4)",
      aspectRatio: "1 / 1",
    };
  }

  return {
    width: "80px",
    height: "80px",
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.itemsCount, (idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: "frisbuy-customers-photos-skeleton__item",
        style: _normalizeStyle(itemStyle.value)
      }, null, 4))
    }), 128))
  ]))
}
}

})